<template lang="pug">
.radio-field
  .radio-field__label(v-if="showLabel && fieldLabel")
    span {{ fieldLabel }}
    span.form-field-require-tag(v-show="required")
      | *
  .radio-field__hint(v-if="hint") {{ hint }}
  q-option-group.radio-field__group.form-radio(
    :value="normalizedValue",
    :options="normalizedOptions",
    type="radio",
    :disable="readonly",
    @input="changeValue"
  )
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  /** Данные поля, если radio строится из объекта схемы. */
  field: { type: Object, default: () => ({}) },
  /** Текущее значение radio-поля. */
  value: { type: [String, Number, Boolean], default: () => null },
  /** Опции radio-поля. */
  options: { type: Array, default: () => [] },
  /** Текст label над radio-полем. */
  label: { type: String, default: () => "" },
  /** Флаг отображения label над radio-полем. */
  showLabel: { type: Boolean, default: false },
  /** Текст подсказки под label radio-поля. */
  hint: { type: String, default: () => "" },
  /** Флаг обязательности radio-поля. */
  required: { type: Boolean, default: false },
  /** Флаг readonly режима radio-поля. */
  readonly: { type: Boolean, default: false },
});

const emit = defineEmits([
  /** Эмит изменения значения radio-поля. */
  "change",
]);

const normalizeValue = value => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return String(value);
};

const fieldLabel = computed(() => props.label || props.field?.title || "");
const showLabel = computed(() => props.showLabel);
const hint = computed(() => props.hint || props.field?.instruction || "");
const required = computed(() => props.required || Boolean(props.field?.required));
const normalizedValue = computed(() => normalizeValue(props.value));
const normalizedOptions = computed(() =>
  props.options.map(option => ({
    ...option,
    value: normalizeValue(option.value),
  })),
);

const changeValue = value => {
  emit("change", value);
};
</script>

<script>
export default {
  name: "RadioField",
};
</script>

<style scoped lang="scss">
.radio-field {
  &__label {
    font-size: 16px;
    font-weight: 600;
    color: var(--field-label-color);
  }

  &__hint {
    margin-top: 8px;
    color: var(--field-placeholder-color);
  }

  &__group {
    margin-top: 14px;
  }

  :deep(.q-radio__inner--truthy) {
    color: var(--checkbox-checked);
  }

  :deep(.q-radio__inner--falsy) {
    color: var(--checkbox-unchecked);
  }

  :deep(.q-radio__label) {
    color: var(--field-input-color);
  }
}
</style>
